import React, { Component } from 'react';
import Link from 'react-router-dom/Link';
import classNames from 'classnames';

import {observer} from 'mobx-react';
import uiState, {StatusConstants} from "../../../core/uiState";

import PersonIdentities from '../elements/PersonIdentities'
import styles from './Index.sass';

@observer
export default class IndexView extends Component {

    async componentWillMount() {
        this.setUpObserver();

        if (this.props.store.isPopulated) {
            return
        }

        uiState.setStatus(StatusConstants.RENDERING);
        await this.props.store.populate();
        uiState.setStatus(StatusConstants.READY);
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    componentWillUnmount() {
        this.tearDownObserver();
    }

    setUpObserver() {
        this.observer = new IntersectionObserver(entries => {
            for (let i = 0; i < entries.length; i++) {
                let entry = entries[i];
                if (entry.intersectionRatio > 0) {
                    this.observer.unobserve(entry.target);
                    entry.target.src = entry.target.dataset.src;
                }
            }
        }, {
            rootMargin: '50px 0px',
            threshold: 0.01
        });
    }

    tearDownObserver() {
        this.observer.disconnect();
        this.observer = null;
    }

    render() {

        let blocks = [];

        const people = this.props.store.people;

        return (
            <div className={styles.root}>
                {people.map((person, i) => {

                    let result;
                    const block = <PersonSummaryView className={classNames({'right': ++i % 2})} person={person} observer={this.observer} history={this.props.history} />;

                    blocks.push(block);

                    if (!(i % 2) || i >= people.length) {
                        result = <section className={classNames(styles.strip, {'skewed': !(i % 2)})}>
                                <div className="larger grid">
                                    {blocks}
                                </div>
                            </section>;
                        blocks = []
                    }

                    return result
                })}
            </div>
        );
    }
}

class PersonSummaryView extends Component {

    constructor(props, context) {
        super(props, context);

        this.onClick = this.onClick.bind(this);
        this.setImageRef = this.setImageRef.bind(this);
    }

    onClick(event) {
        let anchor = event.target;
        // Let anchors resolve naturally. Everything else we treat as bubbling up.
        while (anchor !== null && anchor.tagName !== 'A'.toUpperCase()) {
            anchor = anchor.parentNode;
        }

        if (!anchor) {
            this.props.history.push('/prelegenci/' + this.props.person.slug);
        }
    }

    setImageRef(element) {
        if (this.props.observer !== undefined) {
            if (element) {
                this.photoElement = element;
                this.props.observer.observe(element)
            } else {
                this.props.observer.unobserve(this.photoElement);
            }
        }
    }

    render() {
        const person = this.props.person;

        return <article onClick={this.onClick} className={classNames(styles.person, this.props.className)}>
            <img data-src={person.photo.normal || '/img/people/__placeholder.png'} ref={this.setImageRef} />
            <header>
                <h3 className="g-type-title-section g-type-title-left line-flat line-xs">
                    <Link to={`/prelegenci/${person.slug}`}>
                        <span>{person.name.given}</span> {person.name.family}
                    </Link>
                </h3>
                <PersonIdentities person={person} />
            </header>
            <div className="g-type-minor" dangerouslySetInnerHTML={{__html: person.bio.summary || person.bio.full}} />
        </article>
    }

}


// WEBPACK FOOTER //
// ./src/modules/People/pages/Index.js